/**
 * Worker-side mirror of `src/util/exId.ts`. Kept as a separate file
 * because the embed bundle has no dependency on the server `src/util`
 * tree — duplicating ~10 LOC is cheaper than wiring a shared module
 * through esbuild on both sides.
 *
 * Used by worker-runtime / http-client when a failure originates
 * inside the worker (transpile, marker resolver throw, fetch transport
 * error) and there is no server-minted `exId` to thread through.
 * Logged via `console.error("[EX:<id>]", err)` so devtools shows the
 * same tag the user reads off the error banner.
 */

const HEX = "0123456789ABCDEF";

/** Mint a fresh error-correlation tag (10 uppercase hex chars). */
export function newExId(): string {
  const buf = new Uint8Array(5);
  crypto.getRandomValues(buf);
  let out = "";
  for (let i = 0; i < buf.length; i++) {
    const b = buf[i]!;
    out += HEX[(b >> 4) & 0xf]! + HEX[b & 0xf]!;
  }
  return out;
}

/** Render an `exId` as the display tag, e.g. `"[EX:A1B2C3D4E5]"`. */
export const formatExTag = (exId: string): string => `[EX:${exId}]`;
